import Vue from 'vue'

export default [
  {
    path: '/point/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: 'orderFood', // 書籤/主選單用，由父層 beforeEnter 導向 orderFoodV3
        name: 'pointOrderFood',
        component: () => import('@/views/Point/OrderFood/OrderFoodEntry.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      },
      {
        path: 'orderFoodV2', // 舊版點餐入口頁，保留路徑供已儲存的書籤導向新版入口頁
        redirect: { name: 'orderFoodV3' }
      },
      {
        path: 'orderFoodV3', // 點餐入口頁
        name: 'orderFoodV3',
        component: () => import('@/views/Point/OrderFood/OrderFoodEntry.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      {
        path: 'orderFoodItemManagement', // 點餐使用項目管理
        name: 'orderFoodItemManagement',
        component: () => import('@/views/Point/OrderFood/OrderFoodItemManagement.vue'),
        meta: {
          prev: 'orderFoodV3'
        }
      },
      {
        path: 'orderFoodMenuEdit/:id',
        name: 'orderFoodMenuEdit',
        component: () => import('@/views/Point/OrderFood/OrderFoodMenuEdit.vue'),
        meta: {
          prev: 'orderFoodItemManagement'
        }
      },
      {
        path: 'orderFoodSpecEdit/:id',
        name: 'orderFoodSpecEdit',
        component: () => import('@/views/Point/OrderFood/OrderFoodSpecEdit.vue'),
        meta: {
          prev: 'orderFoodItemManagement'
        }
      },
      {
        path: 'orderFoodRecord', // 舊點餐紀錄(V1)，保留路徑供已儲存的書籤導向餐點訂單
        redirect: { name: 'orderFoodManagement' }
      },
      {
        path: 'orderFoodRecordList', // 點餐紀錄列表(V2)，保留路徑供已儲存的書籤導向餐點訂單
        redirect: { name: 'orderFoodManagement' }
      },
      {
        path: 'orderFoodExportReport', // 匯出點餐報表
        name: 'orderFoodExportReport',
        component: () => import('@/views/Point/OrderFood/OrderFoodExportReport.vue'),
        meta: {
          prev: 'orderFoodManagement'
        }
      },
      {
        path: 'orderFoodCounter', // 櫃檯點餐
        name: 'orderFoodCounter',
        component: () => import('@/views/Point/OrderFood/OrderFoodCounter.vue'),
        meta: {
          prev: 'orderFoodV3',
          keepAlive: true
        }
      },
      {
        path: 'orderFoodPickup', // 住戶取餐
        name: 'orderFoodPickup',
        component: () => import('@/views/Point/OrderFood/OrderFoodPickup.vue'),
        meta: {
          prev: 'orderFoodV3'
        }
      },
      {
        path: 'orderFoodManagement', // 餐點訂單
        name: 'orderFoodManagement',
        component: () => import('@/views/Point/OrderFood/OrderFoodManagement.vue'),
        meta: {
          prev: 'orderFoodV3'
        }
      },
      {
        path: 'orderFoodTableQrCodePrint', // 列印桌號QRCode
        name: 'orderFoodTableQrCodePrint',
        component: () => import('@/views/Point/OrderFood/OrderFoodTableQrCodePrint.vue'),
        meta: {
          header: 'none',
          footer: 'none',
          logoutinfo: 'none',
          isNoNeedToLogin: true
        }
      },
      {
        path: 'report',
        name: 'pointReport',
        component: () => import('@/views/Point/ReportView.vue'),
        meta: {
          prev: 'mainPage/pointManage'
        }
      },
      {
        path: 'noteTemplate',
        name: 'noteTemplate',
        component: () => import('@/views/Point/NoteTemplate.vue'),
        meta: {
          prev: 'mainPage/pointManage'
        }
      }
    ],
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('loginUserInfo') && !JSON.parse(localStorage.getItem('loginUserInfo'))) {
        Vue.prototype.$alert('登入過期或驗證失敗，請重新登入', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          next({ name: 'LoginMain' })
        })
      } else {
        if (to.path === '/point/orderFood') {
          next({ name: 'orderFoodV3' })
        } else {
          next()
        }
      }
    }
  }
]
